var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 19.778,
      height: 17.354,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("clipPath", {
      id: "a"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fill: "none",
      d: "M0 0H19.778V17.354H0z"
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", null,
    /*#__PURE__*/
    React.createElement("path", {
      d: "M15.836 1.26c-2.6-.971-5.042 1.125-5.745 2.365a.234.234 0 0 1-.4 0C8.984 2.385 6.545.289 3.942 1.26a4.577 4.577 0 0 0-2.919 4.623c.372 4.677 8.866 10.471 8.866 10.471s8.494-5.793 8.866-10.471a4.577 4.577 0 0 0-2.919-4.623z",
      fill: "none",
      stroke: "#041f47",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }))))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgHeart, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/heart.0cddb7cb.svg";
export { ForwardRef as ReactComponent };